export enum EnumModule {
    Map = 'Map',
    Map_GlobalVessel = 'Map.GlobalVessel',

    VesselVisit = 'VesselVisit',
    VesselSchedule = 'VesselSchedule',
    BerthPlanning = 'BerthPlanning',
    MasterDataLocation = 'MasterData.Location',
    MasterDataOrganization = 'MasterData.Organization',
    MasterDataUser = 'MasterData.User',
    MasterDataVessel = 'MasterData.Vessel',
}

export interface IRootModulePathMapping {
    path: string;
    name: EnumModule | string;
}

export class RootModulePathMappings {

    static Map: IRootModulePathMapping = {
        path: 'map',
        name: EnumModule.Map,
    };

    static VesselVisit: IRootModulePathMapping = {
        path: 'vessel-visit',
        name: EnumModule.VesselVisit,
    };

    static VesselSchedule: IRootModulePathMapping = {
        path: 'vessel-schedule',
        name: EnumModule.VesselVisit,
    };

    static BerthPlanning: IRootModulePathMapping = {
        path: 'berth-planning',
        name: EnumModule.BerthPlanning,
    };

    static MasterDataLocation: IRootModulePathMapping = {
        path: 'master-data/location',
        name: EnumModule.MasterDataLocation,
    };

    static MasterDataOrganization: IRootModulePathMapping = {
        path: 'master-data/organization',
        name: EnumModule.MasterDataOrganization,
    };

    static MasterDataUser: IRootModulePathMapping = {
        path: 'master-data/user',
        name: EnumModule.MasterDataUser,
    };

    static MasterDataVessel: IRootModulePathMapping = {
        path: 'master-data/vessel',
        name: EnumModule.MasterDataVessel,
    };

    static modules: IRootModulePathMapping[] = [
        RootModulePathMappings.Map,
        RootModulePathMappings.VesselVisit,
        RootModulePathMappings.VesselSchedule,
        RootModulePathMappings.BerthPlanning,
        RootModulePathMappings.MasterDataLocation,
        RootModulePathMappings.MasterDataOrganization,
        RootModulePathMappings.MasterDataUser,
        RootModulePathMappings.MasterDataVessel,
    ];

    static getModuleByPath(url: string): IRootModulePathMapping | undefined {
        const paths = url.split('?')[0].split('/').filter(x => x).map(x => x.toLowerCase());
        const path = paths.join('/');
        return this.modules.find(
            (m) => {
                const modulePath = m.path.toLowerCase();
                return modulePath.indexOf("/") >= 0 ? path.startsWith(modulePath) : path === modulePath;
            }
        );
    }

    static getModuleByName(name: string | EnumModule): IRootModulePathMapping | undefined {
        return this.modules.find(
            (m) => m.name.toString().toLowerCase() === name.toLowerCase()
        );
    }
}
